// A data vem como "AAAA-MM-DD" (às vezes com hora). Lida pelo texto, e não
// por new Date(), que a trata como UTC e no fuso de Brasília volta um dia.
const parts = (dateString) => {
    const [yyyy, mm, dd] = String(dateString || '').slice(0, 10).split('-');
    return { yyyy, mm, dd };
};

const formatDate = (dateString) => {
    const { dd, mm } = parts(dateString);
    return `${dd}/${mm}`;
};

export const frequency = (key, dates) => {
    const firstDate = formatDate(dates.first_date);
    switch (parseInt(key)) {
        case 0:
            return `Apenas em ${firstDate}/${parts(dates.first_date).yyyy}`;
        case 1:
            return `Mensal (Dia ${parseInt(parts(dates.first_date).dd, 10)})`;
        case 2:
            return `Trimestral (${firstDate}, ${formatDate(dates.second_date)}, ${formatDate(dates.third_date)}, ${formatDate(dates.fourth_date)})`;
        case 3:
            return `Semestral (${firstDate} e ${formatDate(dates.second_date)})`;
        case 4:
            return `Anual (${firstDate})`;
        default:
            return '';
    }
};
